const errorHandler = (error) => {
  switch (error?.status) {
    case 401:
    case 403:
      window.location.href = "/login.jsp?timeout=true";
      break;
    case 901:
    case 902:
      window.location.href = `/login.jsp?invalidSession=${error.status}`;
      break;
    default:
  }
};

export default errorHandler;
